import { createSlice } from '@reduxjs/toolkit';
import { filter } from 'lodash';
import { UserService } from '_apis_/user';
import { IUserListParams, User } from '../../@types/user';
import { dispatch } from '../store';

// ----------------------------------------------------------------------

type UserState = {
  isLoading: boolean;
  error: boolean;
  userList: User[];
  userListCount: number;
};

const initialState: UserState = {
  isLoading: false,
  error: false,
  userList: [],
  userListCount: 0
};

const userService = new UserService();

const slice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    stopLoading(state) {
      state.isLoading = false;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET USERS
    getUserListSuccess(state, action) {
      state.isLoading = false;
      state.userList = action.payload?.content
        ? action.payload?.content?.map((user: User) => ({
            ...user
          }))
        : [];
      state.userListCount = action.payload.totalElements ? action.payload.totalElements : 0;
    },

    // DELETE USERS
    deleteUserSuccess(state, action) {
      const deleteUser = filter(state.userList, (user) => user.userId !== action.payload);
      state.userList = deleteUser;
    }
  }
});

// Actions
export const { deleteUserSuccess } = slice.actions;

export function getUserList(params: IUserListParams) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await userService.getUsers(params);
      if (response) {
        dispatch(slice.actions.stopLoading());
      }
      dispatch(slice.actions.getUserListSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      dispatch(slice.actions.stopLoading());
    }
  };
}

// Reducer
export default slice.reducer;
